<template>
  <div class="platform-verify-container">
    <div class="verify-card">
      <div class="verify-header">
        <div class="logo">
          <img src="@/assets/omind_logo.png" alt="OMIND" class="logo-img" />
        </div>
        <h1>Verify Your Account</h1>
      </div>

      <div v-if="loading" class="verify-status">
        <div class="spinner"></div>
        <p>Verifying your account...</p>
      </div>

      <div v-else-if="success" class="verify-status success">
        <div class="success-icon">✓</div>
        <h2>Account Verified!</h2>
        <p>{{ successMessage }}</p>
        <button @click="redirectToLogin" class="btn-primary">
          Go to Login
        </button>
      </div>

      <div v-else-if="error" class="verify-status error">
        <div class="error-icon">✗</div>
        <h2>Verification Failed</h2>
        <p>{{ errorMessage }}</p>
        <button @click="redirectToLogin" class="btn-secondary">
          Go to Login
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

// Same-origin / reverse-proxy path as adminApi (no env base URL)
const platformAxios = axios.create({
  baseURL: '/content-management-api',
});

export default {
  name: 'PlatformVerify',
  data() {
    return {
      loading: true,
      success: false,
      error: false,
      successMessage: '',
      errorMessage: '',
    };
  },
  mounted() {
    this.verifyAccount();
  },
  methods: {
    async verifyAccount() {
      const { email, key } = this.$route.query;

      if (!email || !key) {
        this.error = true;
        this.loading = false;
        this.errorMessage = 'Invalid verification link. Missing email or verification key.';
        return;
      }

      try {
        const response = await platformAxios.post('/auth/platform/verify', {
          email: decodeURIComponent(email),
          validationKey: decodeURIComponent(key),
        });

        if (response.data.success) {
          this.success = true;
          this.loading = false;
          this.successMessage = response.data.message || 'Your account has been verified successfully. You can now log in.';
        } else {
          this.error = true;
          this.loading = false;
          this.errorMessage = response.data.message || 'Verification failed. Please try again or contact support.';
        }
      } catch (err) {
        this.error = true;
        this.loading = false;
        this.errorMessage = err.response?.data?.message || 'Verification failed. The link may be invalid or expired.';
      }
    },
    redirectToLogin() {
      this.$router.push('/platform/login');
    },
  },
};
</script>

<style scoped>
.platform-verify-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #fef7f0 0%, #fff5eb 100%);
  padding: 2rem;
}

.verify-card {
  background: white;
  border-radius: 1rem;
  box-shadow: 0 4px 24px rgba(228, 130, 26, 0.1);
  padding: 3rem;
  max-width: 500px;
  width: 100%;
  text-align: center;
}

.verify-header {
  margin-bottom: 2rem;
}

.logo {
  margin-bottom: 1.5rem;
}

.logo-img {
  width: 120px;
  height: auto;
}

h1 {
  font-size: 1.75rem;
  font-weight: 600;
  color: #1E2019;
  margin-bottom: 0.5rem;
}

.verify-status {
  padding: 2rem 0;
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #e4821a;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  margin: 0 auto 1.5rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.success-icon,
.error-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  font-weight: bold;
  margin: 0 auto 1.5rem;
}

.success-icon {
  background: #10b981;
  color: white;
}

.error-icon {
  background: #ef4444;
  color: white;
}

.verify-status h2 {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #1E2019;
}

.verify-status p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 2rem;
}

.btn-primary,
.btn-secondary {
  padding: 0.75rem 2rem;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  font-size: 1rem;
  transition: all 0.2s;
}

.btn-primary {
  background: #e4821a;
  color: white;
}

.btn-primary:hover {
  background: #c86e15;
}

.btn-secondary {
  background: #f3f4f6;
  color: #374151;
}

.btn-secondary:hover {
  background: #e5e7eb;
}
</style>
